import { lagOgVisInaktivitetsModal } from './InaktivitetsModal';
import { kallSjekkOmSesjonUtloper } from './api';
import type { InaktivitetsResponseType } from './types';

/**
 * Start sjekk for inaktivitet uten å bruke dynamic import
 * Primært skal brukes til SPA applikasjoner som ikke tar i bruk AssetLoader.
 *
 * Grunnen er at rollup-plugin-sri pakken som vi bruker for å sette integrity
 * funker ikke med dynamic imports, og kommer til å krasje siden i miljø.
 */
const grunnetInaktivitet = true;
const FallbackIntervalMilliSeconds = 5 * 60 * 1000; // 5 min

export function startSjekkForInaktivitetUtenDynamicImport(bekreft: InaktivitetsResponseType['bekreft'] = false) {
  kallSjekkOmSesjonUtloper({ grunnetInaktivitet, bekreft })
    .then((res) => {
      if (res.skalViseModal) {
        lagOgVisInaktivitetsModal({ erInaktivitetsVariant: res.inaktivitet! });
      }
      if (!res.tidTilNesteSjekkSekunder) {
        // Dette skal så å si aldri skje, men er føre var her.
        throw new Error('Tid mangler');
      }
      setTimeout(() => startSjekkForInaktivitetUtenDynamicImport(res.bekreft), res.tidTilNesteSjekkSekunder * 1000);
    })
    .catch(() => {
      setTimeout(() => startSjekkForInaktivitetUtenDynamicImport(), FallbackIntervalMilliSeconds);
    });
}

export default startSjekkForInaktivitetUtenDynamicImport;
